import PropTypes from "prop-types";

function CartIcon({ color, className }) {
  return (
    <svg
      version="1.1"
      fill="#ceb07c"
      id="Capa_1"
      fill={color}
      className={className}
      x="0px"
      y="0px"
      viewBox="0 0 480.808 480.808"
    >
      <path
        d="M436.684,447.099l-41.734-317.189c-1.15-8.741-5.653-16.526-12.075-22.106l-49.315-49.316
	c-1.97-1.969-4.64-3.075-7.425-3.075h-15.426C303.068,23.666,274.45,0,240.394,0c-34.056,0-62.673,23.666-70.313,55.412h-15.451
	c-2.785,0-5.455,1.106-7.425,3.075L97.512,108.18c-6.195,5.551-10.528,13.182-11.653,21.729L44.124,447.098
	c-1.148,8.723,1.388,17.367,6.957,23.718c5.569,6.351,13.81,9.993,22.607,9.993h333.431c8.798,0,17.038-3.642,22.607-9.993
	C435.296,464.465,437.832,455.82,436.684,447.099z M344.312,98.939h-31.585V76.412h9.058L344.312,98.939z M240.394,21
	c28.305,0,51.333,23.028,51.333,51.333v26.606H189.062V72.333C189.062,44.028,212.089,21,240.394,21z M158.979,76.412h9.083v22.528
	h-31.61L158.979,76.412z M106.679,132.649c0.892-6.771,7.664-12.71,14.493-12.71h46.89v38.333c0,5.799,4.701,10.5,10.5,10.5
	c5.799,0,10.5-4.701,10.5-10.5v-38.333h102.665v38.333c0,5.799,4.701,10.5,10.5,10.5c5.799,0,10.5-4.701,10.5-10.5v-38.333h46.91
	c3.576,0,7.128,1.638,9.836,4.161l0.077,0.077c0.026,0.027,0.056,0.049,0.083,0.075c2.38,2.277,4.081,5.242,4.496,8.396
	l34.884,265.126H71.794L106.679,132.649z M413.939,456.969c-1.605,1.831-4.027,2.839-6.819,2.839H73.689
	c-2.792,0-5.214-1.008-6.819-2.839c-1.605-1.831-2.289-4.363-1.925-7.131l4.087-31.063h342.745l4.087,31.063
	C416.228,452.606,415.544,455.138,413.939,456.969z"
      />
      <g></g>
    </svg>
  );
}

CartIcon.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
};

export default CartIcon;
